export namespace Icons {

    export const preload = ['/dist/assets/icons/bundle.svg'];

    export function insertIcons() {
        try {
            if (!(this.status === 200) || this.responseText.startsWith('<!DOCTYPE html>'))
                return
            const oldSvg = document.getElementById('svgRoot');

            if (this.responseText.includes('<symbol')) {
                const [_, ...symbols] = [...this.responseText.split('<symbol')].map(symbol => `<symbol${symbol.replace('</svg>', '')}`);

                oldSvg.innerHTML = `${oldSvg.innerHTML}${symbols.join('')}`;
            } else {
                const urlSegments = this.responseURL.split('/');
                const id = urlSegments[urlSegments.length - 1].replace('.svg', '');
                const _content = (/<svg[^>]*>([\s\S]*)<\/svg>/gi).exec(this.responseText)[1];
                const viewBox = (/viewBox="([^"]*)"/gi).exec(this.responseText)[1];

                oldSvg.innerHTML = `${oldSvg.innerHTML} <symbol id="${id}" fill="currentColor" viewBox="${viewBox}">${_content}</symbol>`;
            }
            document.body.append(oldSvg)
        }
        catch (error) {
            console.log(error);
        }
    }

    export function loadIcons(paths: string[]) {
        // tslint:disable-next-line: no-shadowed-variable
        return Promise.allSettled(paths.map(path =>
            new Promise((resolve, reject) => {
                const svgRequest = new XMLHttpRequest();
                svgRequest.addEventListener('load', insertIcons);
                svgRequest.open('GET', path);
                svgRequest.setRequestHeader('Accept', 'image/svg+xml');
                svgRequest.onerror = () => reject('Icons request failed');
                svgRequest.ontimeout = () => reject('Icons request timedout');
                svgRequest.onabort = () => reject('Icons request aborted');
                svgRequest.onloadend = () => resolve({});
                svgRequest.send();
            }).catch()
        ));
    }

    export function setFavIcon(icon: string) {
        (document.head.querySelector('link[rel="icon"]') as HTMLLinkElement).setAttribute('href', icon);
    }
}
